import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "pages/staff_activity/staff_gross_sales/"
});

export const api = {
  getFilters(params) {
    return instance.get("get_filters", { params });
  },
  getData(params) {
    return instance.post("get_table", params);
  }
};
